const KEY = "veyra.studio.v1";

export const repository = {
  load() {
    try {
      const raw = globalThis.localStorage?.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return { __error: true };
    }
  },
  save(state) {
    try {
      globalThis.localStorage?.setItem(KEY, JSON.stringify(state));
    } catch {
      /* cuota o modo privado: se ignora en Fase 1 */
    }
  },
  clear() {
    globalThis.localStorage?.removeItem(KEY);
  },
};
